// Animation utility to handle scroll animations
export const setupScrollAnimation = () => {
  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  
  const checkVisibility = () => {
    animatedElements.forEach(element => {
      const elementPosition = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Element becomes visible when it enters the viewport
      if (elementPosition.top < windowHeight * 0.85) {
        element.classList.add('show');
      }
    });
  };
  
  // Check elements visibility initially and on scroll
  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', checkVisibility);
  window.addEventListener('load', checkVisibility);
  
  // Trigger initial check
  checkVisibility();
};